import React, { useEffect, useRef, useState, FC } from 'react';
import { AutoComplete, Button, Col, InputRef, Row } from 'antd';
import { QueryResult } from 'src/core/stores/data-store';
import HttpService from 'src/core/services/http.service';
import { container } from 'src/inversify.config';
import { useTranslation } from 'react-i18next';
import { curateString } from 'src/core/utils/object';

export const AutocompleteTextFilter: FC<any> = ({
  onChange,
  baseUrl,
  fieldName,
  fieldValue = '',
  filter,
  value,
  extraQuery = '',
  suggestionsParser = undefined,
}) => {
  const inputRef = useRef<InputRef>(null);
  const [options, setOptions] = useState<{ value: string }[]>([]);
  const [displayValue, setDisplayValue] = useState(value);
  let httpService = container.get(HttpService);
  const textRef = useRef<string>('');
  const { t } = useTranslation();
  const suggestionsQueueIndex = useRef<number>(0);

  useEffect(() => {
    inputRef.current?.focus();
  }, [inputRef]); // eslint-disable-line react-hooks/exhaustive-deps

  const updateOptions = async (newfilter: string) => {
    suggestionsQueueIndex.current = suggestionsQueueIndex.current + 1;
    const next = `&${extraQuery}`;
    const MaxAutoCompleteEntries = 5;

    const queryApply = `$apply=groupby((${fieldName}))`;
    const queryFilter = `$filter=(contains(${fieldName}, '${encodeURIComponent(newfilter)}') and ${fieldName} ne null)`;
    const extraFilters = filter ? ` and ${filter}` : '';
    const queryTake = `$top=${MaxAutoCompleteEntries}`;
    const query = `${queryApply}&${queryFilter}${extraFilters}&${queryTake}${next}`;

    const queueIndex = suggestionsQueueIndex.current;
    const response = await httpService.get<QueryResult<any>>(`${baseUrl}?${query}`);
    const suggestionNames: string[] = suggestionsParser ? suggestionsParser(response) : response.data.items.map((v: any) => v[fieldValue]);
    const uniqueSuggeestionNames = new Set(suggestionNames);
    const suggestions = [...uniqueSuggeestionNames].map((value, index) => ({ value, key: index }));
    if (queueIndex >= suggestionsQueueIndex.current) {
      setOptions(suggestions);
    }
  };

  useEffect(() => {
    if (value === undefined) {
      updateOptions('');
    }
    setDisplayValue(value);
    textRef.current = value;
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ margin: '10px 20px 10px 20px' }}>
      <Row gutter={[10, 0]} style={{ width: 'fit-content' }}>
        <Col style={{ minWidth: '250px' }}>
          <AutoComplete
            className="filter-circle-clear"
            allowClear
            onClear={() => {
              textRef.current = '';
              setDisplayValue('');
              updateOptions('');
              onChange('');
            }}
            options={options}
            style={{ width: '100%', marginRight: '50px' }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onChange(textRef.current);
              }
            }}
            onChange={(text) => {
              updateOptions(text);
              setDisplayValue(text);
              textRef.current = text;
            }}
            onSelect={(text) => {
              onChange(text);
            }}
            value={displayValue}
          />
        </Col>
        <Col>
          <Button
            type="primary"
            style={{ height: '40px' }}
            disabled={((displayValue as string) ?? '').trim().length === 0}
            onClick={() => {
              onChange(curateString(textRef.current));
            }}
          >
            {t('Go')}
          </Button>
        </Col>
      </Row>
    </div>
  );
};
